import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WalletsComponent } from '@teem/wallets-module/wallets.component';
import { WalletsRoutingModule } from '@teem/wallets-module/wallets-routing.module';
import { BannerComponent } from '@teem/wallets-module/components/banner/banner.component';
import { TopupComponent } from '@teem/wallets-module/modals/topup/topup.component';
import { WithdrawComponent } from '@teem/wallets-module/modals/withdraw/withdraw.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    WalletsComponent,
    BannerComponent,
    TopupComponent,
    WithdrawComponent
  ],
  imports: [
    WalletsRoutingModule,
    CommonModule,
    FormsModule  
  ]
})
export class WalletsModule { }
